import { useState } from 'react';
import type { PartnerItem } from '../types';
import { CollapsibleItems } from './Expandable';
import { useLanguage } from '../i18n/context';
import { getUi } from '../i18n/ui';
import styles from '../App.module.css';

interface PartnerListProps {
  items: PartnerItem[];
}

export function PartnerList({ items }: PartnerListProps) {
  const { locale } = useLanguage();
  const ui = getUi(locale);
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <CollapsibleItems total={items.length} initial={4}>
      {(visible) => (
        <ul className={styles.partnerList}>
          {items.slice(0, visible).map((item) => {
            const open = openId === item.id;
            const detail =
              item.detail ||
              (locale === 'en'
                ? 'Tap + for ideas on how to help. Talk with mama about what feels supportive this week.'
                : locale === 'zh'
                  ? '点击＋可查看具体做法。和妈妈商量这周怎样帮忙最安心。'
                  : '＋を押すと具体的なやり方が開きます。ママと相談して、今週できそうなことから。');
            return (
              <li key={item.id} className={`${styles.partnerItem} ${open ? styles.partnerItemOpen : ''}`}>
                <button
                  type="button"
                  className={styles.partnerToggle}
                  aria-expanded={open}
                  onClick={() => setOpenId(open ? null : item.id)}
                >
                  <span className={styles.partnerIcon} aria-hidden="true">
                    {open ? '−' : '＋'}
                  </span>
                  <span className={styles.partnerText}>{item.text}</span>
                  <span className={styles.partnerDetailHint}>
                    {open ? ui.expand.hideDetail : ui.expand.detail}
                  </span>
                </button>
                {open ? <p className={styles.partnerDetail}>{detail}</p> : null}
              </li>
            );
          })}
        </ul>
      )}
    </CollapsibleItems>
  );
}
